import { defineStore } from 'pinia';
import { StoreModuleName } from '../../constants';
import { UserInfo } from './types';
import { fetchUserInfo, getUserSubject } from '~/src/api/modules/user';
import { CustomFetchContext } from '~/src/api/requests/types';
import { ApiResponse } from '~/src/api/types';
import { GLOBAL_CONFIG, getFullUrl } from '~/configs/environment/environment';
import { useRoute } from 'vue-router';

export const useUserStore = defineStore(StoreModuleName.USER, () => {
  const route = useRoute();
  const userInfo = ref<UserInfo>();
  const isLogin = ref(false);
  const subjectId = ref('');
  const miniProgramSubjectId = ref(''); // 小程序携带的subjectId

  const updateUserInfo = async (fetchContext: CustomFetchContext) => {
    const res = await fetchUserInfo({}, { credentials: 'include' }, fetchContext).catch(() => {
      return {
        data: {},
      } as ApiResponse<UserInfo>;
    });

    userInfo.value = res.data || {};

    if (userInfo.value.userId) {
      isLogin.value = true;
    }

    return userInfo.value;
  };

  const getUserInfo = async (fetchContext?: CustomFetchContext) => {
    if (userInfo.value) {
      return userInfo.value;
    }

    if (!fetchContext) {
      return {} as UserInfo;
    }

    return updateUserInfo(fetchContext);
  };

  const updateUserSubjectId = async (fetchContext: CustomFetchContext) => {
    const res = await getUserSubject({}, fetchContext).catch(() => {
      return {
        data: {
          subjectId: '',
        },
      };
    });

    subjectId.value = (res.data.subjectId as string) || '';

    return subjectId.value;
  };

  const getUserSubjectId = async (fetchContext?: CustomFetchContext) => {
    if (subjectId.value) {
      return subjectId.value;
    }

    if (!fetchContext) {
      return '';
    }

    return updateUserSubjectId(fetchContext);
  };

  const updateMiniProgramSubjectId = (userSubject: string) => {
    miniProgramSubjectId.value = userSubject;

    if (process.client) {
      window.localStorage.setItem('MINI_PROGRAM_SUBJECT_ID', userSubject);
    }
  };

  const handleLogin = () => {
    window.location.href = `${GLOBAL_CONFIG.envConfig.homeUrl}/index?reback=${encodeURIComponent(getFullUrl(route.fullPath, true))}`;
  };

  return {
    isLogin,
    userInfo,
    getUserInfo,
    updateUserInfo,
    subjectId,
    miniProgramSubjectId,
    getUserSubjectId,
    updateUserSubjectId,
    handleLogin,
    updateMiniProgramSubjectId,
  };
});
